import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * LinkText のスタイル
 */
export const linkTextStyle = tv({
    defaultVariants: {
        color: 'link',
        isGroup: false,
    },
    extend: textStyle,
    variants: {
        isGroup: {
            false: ['hover:underline focus:underline hover:cursor-pointer'],
            true: [
                'group-hover:underline group-focus:underline group-hover:cursor-pointer',
            ],
        },
    },
});
